import { environment } from "src/environments/environment";

/**
 * Returns true if the brand name of the current environment is zonar.
 */
export const isZonarTheme = () => {
	return environment.brand.name === "zonar";
};
